import { SaveButtonState } from '../save/SaveButtonProps.ts';
import { ItemType } from '../_types/item.ts';
import { isCwpUserSignedIn } from '../../../../_helpers/isCwpUserSignedIn.ts';

interface DataLinkEvent {
	linkType: 'o' | 'd';
	link_name: string;
	userId: string;
}

interface SaveButtonDataLinkEvent extends DataLinkEvent {
	linkEvent: string;
	savedContent: string;
}

interface FileDownloadDataLinkEvent extends DataLinkEvent {
	fileDownloadUrl: string;
}

interface VoteDataLinkEvent extends DataLinkEvent {
	advisorPolls: string;
}

export interface GlobalAnalyticsWindow extends Window {
	globalAnalyticsParams?: {
		pendingDataLinkEvent: string;
		webTrackingId: string;
		isInternalLogin: string;
		emailAddress: string;
	};
	utag?: {
		link: (
			params:
				| DataLinkEvent
				| VoteDataLinkEvent
				| SaveButtonDataLinkEvent
				| FileDownloadDataLinkEvent
		) => void;
	};
}

export const sendSaveButtonDataLinkEvent = (
	dataLinkEvent: string,
	operation: SaveButtonState
) => {
	if (!isCwpUserSignedIn()) {
		sendDataLinkEvent(dataLinkEvent);
		return;
	}

	const linkEvent =
		operation === SaveButtonState.SAVED ||
		operation === SaveButtonState.SAVE_CLICKED
			? 'content saved'
			: 'content unsaved';
	const localWindow = window as GlobalAnalyticsWindow;

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	localWindow.utag.link({
		linkType: 'o',
		link_name: dataLinkEvent.toLowerCase(),
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		userId: localWindow.globalAnalyticsParams.webTrackingId,
		linkEvent: linkEvent,
		savedContent: dataLinkEvent.toLowerCase(),
	});
};

export const sendVoteDataLinkEvent = (dataLinkEvent: string) => {
	const localWindow = window as GlobalAnalyticsWindow;
	const isInternalLogin =
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		localWindow.globalAnalyticsParams.isInternalLogin === 'true';
	if (isInternalLogin) {
		return;
	}

	const fixedDataLinkEvent = dataLinkEvent.toLowerCase().replace('vote|', '');
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	localWindow.utag.link({
		linkType: 'o',
		link_name: fixedDataLinkEvent,
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		userId: localWindow.globalAnalyticsParams.webTrackingId,
		linkEvent: 'polls voted',
		advisorPolls: fixedDataLinkEvent,
	});
};

export const sendSeriesItemCardDataLinkEvent = (
	dataLinkEvent: string,
	itemType: ItemType,
	href: string
) => {
	sendDataLinkEvent(dataLinkEvent);

	if (itemType === 'DOCUMENT') {
		const localWindow = window as GlobalAnalyticsWindow;

		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		localWindow.utag.link({
			linkType: 'd',
			link_name: href.toLowerCase(),
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			userId: localWindow.globalAnalyticsParams.webTrackingId,
			fileDownloadUrl: href.toLowerCase(),
		});
	}
};

export const sendDataLinkEvent = (dataLinkEvent?: string) => {
	if (!dataLinkEvent) {
		return;
	}
	const localWindow = window as GlobalAnalyticsWindow;

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	localWindow.utag.link({
		linkType: 'o',
		link_name: dataLinkEvent.toLowerCase(),
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		userId: localWindow.globalAnalyticsParams.webTrackingId,
	});
};
